import { homeServerUrl } from "../environment/Environment";
import axiosInstance from "../external-library/axios-interceptor/Interceptor";

const DATA_ENDPOINTS = {
    wasteData: '/admin/data/waste-data',
    wasteCategoryData: '/admin/data/waste-categories',
    transportationData: '/admin/data/transport',
    fuelData: '/admin/data/fuel',
    prodDB: '/admin/data/prod-db',
    technologyData: '/admin/data/tech-db',
    mcdmDB: '/admin/data/mcdm-db',
    countries: '/admin/data/countries'
};

export const downloadData = async (dataType) => {
    const endpoint = DATA_ENDPOINTS[dataType];

    return await axiosInstance.get(
        `${homeServerUrl}${endpoint}`,
        {
            responseType: "blob",
            headers: {
                'Accept': 'text/csv, application/octet-stream',
            }
        }
    );
};


export const uploadData = async (dataType, formData, countryName = null) => {
    const endpoint = DATA_ENDPOINTS[dataType];

    console.log("uploading: " + dataType);
    return await axiosInstance.post(
        `${homeServerUrl}${endpoint}`,
        formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
};
